import { useEffect } from 'react';

export const useKeyDown = (key: string, callback: Function, when = true) => {
    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === key && when) {
                event.preventDefault();
                callback();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [callback, key, when]);
};
